@if (computedStatistic()) {
    <div
        class="flex flex-wrap flex-col justify-center items-center p-6 rounded-xl bg-background h-full"
        [class.hover-content]="isHoverContent()"
        [class.min-h-64]="useMinH64()"
        [class.min-h-72]="useMinH72()">
        <p
            class="text-5xl font-bold pt-2.5"
            [style.color]="hoverValueInformationsColor()">
            {{ value().x }}{{ isPercent() }}
        </p>
        <p class="text-lg font-medium leading-none text-center">
            {{ computedStatistic().name | transloco: { COUNT: value().x } }}
        </p>
        <span
            class="text-on-surface leading-none text-center"
            [class.pb-10]="pbNoDesc10()"
            [class.pb-7]="pbNoDesc7()"
            >{{ computedStatistic().description ?? '&nbsp;' }}</span
        >
        <span
            class="text-on-surface leading-none text-center"
            [class.pb-20]="pbValue20()"
            [class.pb-7]="pbValue7()"
            >{{ (!value().x ? 'noStatData' : '') | transloco }}</span
        >
    </div>
}
